export const CREATE_GROUP_EVENT_NEW_PATH = '/pga-coach/bookings/events/new'

export const shouldShowCreateEventQuickStart = ({
  search = '',
  skipQuickStart = false,
} = {}) => !String(search).includes('preload') && !skipQuickStart
